import { render, staticRenderFns } from "./painel-turno-detalhes.vue?vue&type=template&id=9e6abec8&scoped=true&"
import script from "./painel-turno-detalhes.vue?vue&type=script&lang=js&"
export * from "./painel-turno-detalhes.vue?vue&type=script&lang=js&"
import style0 from "./painel-turno-detalhes.vue?vue&type=style&index=0&id=9e6abec8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e6abec8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e6abec8')) {
      api.createRecord('9e6abec8', component.options)
    } else {
      api.reload('9e6abec8', component.options)
    }
    module.hot.accept("./painel-turno-detalhes.vue?vue&type=template&id=9e6abec8&scoped=true&", function () {
      api.rerender('9e6abec8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/painel-turno-detalhes/painel-turno-detalhes.vue"
export default component.exports